import { useField, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { ValueType } from 'react-select';

import { FieldError, FieldLabel } from '../../../common';

import { SuggestFieldBody } from './components';
import { TSuggestFieldProps } from './SuggestField.interface';

export const SuggestField = (props: TSuggestFieldProps): JSX.Element => {
  const { name = '', label, onChange } = props;

  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [{ value }] = useField(name);

  const [localValue, setLocalValue] = useState(props.value);

  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const [inputProps, { error, touched }] = useField({ name });

  const onSelectChange = (chosenValue: ValueType<{ value: unknown }> | null | undefined) => {
    const newValue: ValueType<{ value: unknown }> = chosenValue ?? undefined;

    setFieldTouched(name);
    setFieldValue(name, newValue);
    setLocalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Form.Group controlId={name}>
      <FieldLabel label={label} />
      <SuggestFieldBody {...props} {...inputProps} onChange={onSelectChange} isValid={!error} value={localValue} />
      {touched && error && <FieldError error={error} />}
    </Form.Group>
  );
};
